import React from "react";
import { ShieldCheck, Sprout, MessageCircleHeart } from "lucide-react";

const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Arrives healthy, packed with care",
    text: "Braced, sleeved and shipped early-week so it never sits in a depot. A photo of exactly what we packed, every time.",
  },
  {
    icon: Sprout,
    title: "Chosen for the Irish climate",
    text: "Exotics that actually thrive in our soft, damp midlands air — not catalogue plants that sulk by November.",
  },
  {
    icon: MessageCircleHeart,
    title: "A real person, real advice",
    text: "Ask us anything about your plant. One grower, genuine expertise, an answer that isn't a chatbot.",
  },
];

export default function TrustStrip({ tone = "canvas" }) {
  const dark = tone === "dark";
  return (
    <section className={dark ? "bg-forest-900 text-canvas" : "bg-forest-100/50"}>
      <div className="container-fp grid gap-8 py-12 md:grid-cols-3 md:py-16">
        {ITEMS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="flex gap-4">
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${
                dark ? "bg-canvas/10 text-brass" : "bg-canvas-raised text-forest-700"
              }`}
            >
              <Icon size={22} />
            </span>
            <div>
              <h3
                className={`font-display text-lg leading-tight ${
                  dark ? "text-canvas" : "text-ink"
                }`}
              >
                {title}
              </h3>
              <p className={`mt-1 text-sm ${dark ? "text-canvas/70" : "text-ink-soft"}`}>{text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
